import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/sources/fleets/$id/alerts/$alertId/")({
  staticData: {
    title: "common.alerts",
  },
});
